let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aS0wt")).then(() => parcelRequire('f0a81'));